import React from 'react';
import styles from './styles.module.scss';

export function ObjectExplorerHeadShimmer() {
  return (
    <div className={styles.objectExplorerHead}>
      <span className='shimmer shimmer-line' style={{ width: '161px', height: '12px' }} />
    </div>
  );
}
